<div class="header">
    <div class="title">
        <img src="icons/{{icon}}" width="60px" height="60px" />
        <h2>{{ title }}</h2>
    </div>
</div>